import { Col, CreateForm, notifySnackbarByName, Row, Spacing, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'omni-package-react-core';
import AttachmentRow from '../../../../../components/_AttachmentsRow';
import MessageRow from '../../../../../components/_MessageRow';
import { Message } from '../../../../../interfaces/Message';
import { MessageDetailsPageState } from '../../../../../interfaces/MessageDetailsPageState';
import { MessageDto } from '../../../../../interfaces/dtos/MessageDto';
import getApiRoot from '../../../../../utils/getApiRoot';
import ActionBar from './ActionBar';
import { StyledBlock, StyledDiv, StyledDivHeader, StyledDivider, StyledRowWrapper, StyledText } from './AnswerMail.styles';
import { Mail } from '../../../../../interfaces/Mail';
import Constants from '../../../../../utils/Constants';
import { StyledBoldText } from '../../../MessageDetailsPage.styles';

export interface AnswerMailProps { }

const AnswerMail: FC<AnswerMailProps> = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('MessageDetailsPage');
  const isModificationMode = useScopedSelector((state: MessageDetailsPageState) => state.modificationMode);
  const fromMessageId = useScopedSelector((state: MessageDetailsPageState) => state.messageDetails?.data.id);
  const answerMail = useScopedSelector((state: MessageDetailsPageState) => state.answerMail);
  const navigate = useNavigate();

  if (!isModificationMode) return null;

  const getPayload = (values: Mail) => (
    {
      content: values.message,
      attachments: values.attachments,
    });

  return (
    <>
      <Spacing m-l={-12}>
        {answerMail?.mainRecipient && (
          <StyledDivHeader>
            <StyledBoldText>{t('recipient')}</StyledBoldText><StyledText>{answerMail?.mainRecipient}</StyledText>
          </StyledDivHeader>)}
        <CreateForm<Message, { data: MessageDto }>
          name="mailModificationForm"
          defaultCol={12}
          url={`${getApiRoot()}/messages/${fromMessageId}`}
          valuesSrc="answerMail"
          transformRequest={(values: Mail) => getPayload(values)}
          onSuccess={(response) => {
            redirectTo('/secured-messaging?messageSource=Inbox', navigate);
            dispatch(notifySnackbarByName(Constants.ComposantsName.ClientSpaceSnackBar, `${t('messageAnswerSnackbar', { msgId: response?.data?.data?.referenceNumber })}`));
          }}
        >
          {isModificationMode && (
            <StyledBlock white>
              <Row>
                <Col lg={9} sm={12} xs={12}>
                  <StyledDiv>
                    <StyledRowWrapper><MessageRow autoFocus /></StyledRowWrapper>
                    <StyledRowWrapper><AttachmentRow currentAttachmentNumber={answerMail?.attachments?.length} /></StyledRowWrapper>
                  </StyledDiv>
                </Col>
              </Row>
              <ActionBar />
            </StyledBlock>
          )}
        </CreateForm>
      </Spacing>
      <StyledDivider />
    </>
  );
};

export default AnswerMail;
